import { render, staticRenderFns } from "./Pelapor.vue?vue&type=template&id=2bf50d5a&"
import script from "./Pelapor.vue?vue&type=script&lang=js&"
export * from "./Pelapor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports